module.exports = __webpack_public_path__ + "static/media/medium.d07fc7bb.svg";